<template>
  <div :class="{ 'background': !isCartasLoaded, 'cartas': isCartasLoaded }">
    <nav>
      <HeadAemps v-if="showHeader"/>
      
    </nav>
    <div>
      
    </div>
    <router-view/>
  </div>
</template>

<script>
import HeadAemps from './components/HeadAemps.vue'
export default ({
  components: {
    HeadAemps,
  },
  data() {
    return {
      isCartasLoaded: false,
    };
  },
  computed: {
    showHeader() {
      return this.$route.meta.showHeader !== false;
    },
  },
  watch: {
    $route(to) {
       console.log('Ruta actual:', to.name);
      this.isCartasLoaded = to.name === 'home';
      console.log('isCartasLoaded:', this.isCartasLoaded);

    },
  },

  
});
</script>
<style>
@import './css/style.css';
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
</style>


